import { TodosConfig, HireFormTodoKey, OfferStageTodoKey, TodoItem } from './todoListTypes';

export function unflattenTodos(flatObj: Record<string, any>) {
  const result = {} as { todos: TodosConfig };

  for (const flatKey in flatObj) {
    if (!Object.prototype.hasOwnProperty.call(flatObj, flatKey)) continue;

    const enabled = flatObj[flatKey];
    const parts = flatKey.split('.');

    if (parts.length !== 3 || parts[0] !== 'todos') {
      throw new Error(`Unexpected key format: "${flatKey}"`);
    }

    const [, category, key] = parts as [string, keyof TodosConfig, HireFormTodoKey | OfferStageTodoKey];

    if (!result?.todos) {
      result.todos = {};
    }

    if (!result.todos[category]) {
      (result.todos[category] as TodoItem<string>[]) = [];
    }

    (result.todos[category] as TodoItem<string>[]).push({
      enabled,
      key,
    });
  }

  return result;
}
